export default [
    {name: 'Bahrain', flag: '🇧🇭'},
    {name: 'Saudi Arabia', flag: '🇸🇦'},
    {name: 'Australia', flag: '🇦🇺'},
    {name: 'Italy', flag: '🇮🇹'},
    {name: 'United States', flag: '🇺🇸'},
    {name: 'Spain', flag: '🇪🇸'},
    {name: 'Monaco', flag: '🇲🇨'},
    {name: 'Azerbaijan', flag: '🇦🇿'},
    {name: 'Canada', flag: '🇨🇦'},
    {name: 'Great Britain', flag: '🇬🇧'},
    {name: 'Austria', flag: '🇦🇹'},
    {name: 'France', flag: '🇫🇷'},
    {name: 'Hungary', flag: '🇭🇺'},
    {name: 'Belgium', flag: '🇧🇪'},
    {name: 'Netherlands', flag: '🇳🇱'},
    {name: 'Russia', flag: '🇷🇺'},
    {name: 'Singapore', flag: '🇸🇬'},
    {name: 'Japan', flag: '🇯🇵'},
    {name: 'Mexico', flag: '🇲🇽'},
    {name: 'Brazil', flag: '🇧🇷'},
    {name: 'Abu Dhabi', flag: '🇦🇪'},
    {name: 'Finland', flag: '🇫🇮'},
    {name: 'Germany', flag: '🇩🇪'},
    {name: 'Thailand', flag: '🇹🇭'},
    {name: 'China', flag: '🇨🇳'},
    {name: 'Denmark', flag: '🇩🇰'},
    {name: 'Quatar', flag: '🇶🇦'},
    {name: 'New Zealand', flag: '🇳🇿'},
    {name: 'Argentina', flag: '🇦🇷'}
]

